import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

import { AppSlugContextProvider } from './contexts/AppSlugContext';
import { RemoteSettingsProvider } from './contexts/RemoteSettings';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppRoutes } from './routes';
import {
  AUTH0_AUDIENCE,
  AUTH0_CLIENTID,
  AUTH0_DOMAIN
} from './constants/auth0';

function App() {
  const email = window?.location?.search?.split('email=')[1];

  const isSignUp =
    !!window?.location?.search?.toLowerCase().includes('signup') ||
    !!window?.location?.pathname?.toLowerCase().includes('signup');

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      audience={AUTH0_AUDIENCE}
      clientId={AUTH0_CLIENTID}
      redirectUri={window.location.origin}
      display={isSignUp ? 'signUp' : 'login'}
      login_hint={isSignUp ? email : undefined}
      cacheLocation="localstorage"
    >
      <AppSlugContextProvider>
        <RemoteSettingsProvider>
          <ThemeProvider>
            <AppRoutes />
          </ThemeProvider>
        </RemoteSettingsProvider>
      </AppSlugContextProvider>
    </Auth0Provider>
  );
}

export { App };
